import { IndividualLight } from "@/Common/Api/Individuals/Dto/IndividualLight";
import { ValidateIndividualDuplicateResponse } from "@/Common/Api/Individuals/Dto/ValidateIndividualDuplicateResponse";
import { Person } from "@/Common/Models/Person/Person";

class IndividualApiMappers {
    public static FromFindDuplicateResponseToIndividualLight(findDuplicatesResponse: ValidateIndividualDuplicateResponse): IndividualLight[] {
        const individualLightList: IndividualLight[] = [];

        if (findDuplicatesResponse.DuplicateIndividuals) {
            findDuplicatesResponse.DuplicateIndividuals.forEach(individual => {
                const person = Person.FromSearchIndividualResult(individual) as Person;
                const individualLight: IndividualLight = {
                    Id: individual.ContactId,
                    FirstName: individual.FirstName,
                    LastName: individual.LastName,
                    PreferredName: individual.PreferredName,
                    Prefix: person.prefix,
                    NAM: person.NAM,
                    FileNumber: person.FileNumber,
                    PortalProfileId: individual.PortalProfileId,
                    PortalSyncState: individual.PortalSyncState
                };
                individualLightList.push(individualLight);
            });
        }

        return individualLightList;
    }
}

export { IndividualApiMappers };
